export default {
  slug: "goland",
  code: "GO",
  label: "GoLand",
  isIDE: true,
  krakenDir: "GoLand",
  thumbnailColor: "#3BEA62",
  logoFamily: "ide",
  // The code highlight of the Demo Video banners (Figma "YouTube", "Code
  // highlight color" of the product section).
  codeHighlightColor: "#B74AF7",
};
